import { Link } from 'react-router-dom'

export default function Footer() {
  return (
    <footer className="bg-navy-900 text-navy-200">
      <div className="container-custom py-12 lg:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 lg:gap-12">
          {/* Products */}
          <div>
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">
              Products
            </h3>
            <ul className="space-y-3">
              <li>
                <Link to="/products" className="text-sm hover:text-white transition-colors">
                  All Products
                </Link>
              </li>
              <li>
                <Link to="/products/psa" className="text-sm hover:text-white transition-colors">
                  Klarhead PSA
                </Link>
              </li>
              <li>
                <Link to="/products/wms" className="text-sm hover:text-white transition-colors flex items-center">
                  Klarhead WMS
                  <span className="ml-1.5 px-1.5 py-0.5 text-xs bg-amber-600 text-white rounded">Beta</span>
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-sm hover:text-white transition-colors">
                  Pricing
                </Link>
              </li>
            </ul>
          </div>

          {/* Solutions */}
          <div>
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">
              Solutions
            </h3>
            <ul className="space-y-3">
              <li>
                <Link to="/solutions/3pl" className="text-sm hover:text-white transition-colors">
                  3PL & Fulfillment
                </Link>
              </li>
              <li>
                <Link to="/solutions/distribution" className="text-sm hover:text-white transition-colors">
                  Distribution
                </Link>
              </li>
              <li>
                <Link to="/solutions/law" className="text-sm hover:text-white transition-colors">
                  Law Firms
                </Link>
              </li>
              <li>
                <Link to="/solutions/consulting" className="text-sm hover:text-white transition-colors">
                  Consulting
                </Link>
              </li>
              <li>
                <Link to="/solutions/engineering" className="text-sm hover:text-white transition-colors">
                  Engineering
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">
              Company
            </h3>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-sm hover:text-white transition-colors">
                  About
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm hover:text-white transition-colors">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/trust" className="text-sm hover:text-white transition-colors">
                  Trust & Security
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">
              Legal
            </h3>
            <ul className="space-y-3">
              <li>
                <Link to="/privacy" className="text-sm hover:text-white transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/trust" className="text-sm hover:text-white transition-colors">
                  Trust & Security
                </Link>
              </li>
              <li>
                <a href="mailto:privacy@klarhead.com" className="text-sm hover:text-white transition-colors">
                  privacy@klarhead.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom section */}
        <div className="mt-12 pt-8 border-t border-navy-700">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between">
            <div className="flex items-center">
              <img src="/logo-white.svg" alt="Klarhead" className="h-8" />
            </div>
            <p className="mt-4 md:mt-0 text-sm text-navy-400">
              &copy; {new Date().getFullYear()} Klarhead. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}
